import { render, staticRenderFns } from "./ModalTriangle.vue?vue&type=template&id=23d4045f&scoped=true&"
import script from "./ModalTriangle.vue?vue&type=script&lang=js&"
export * from "./ModalTriangle.vue?vue&type=script&lang=js&"
import style0 from "./ModalTriangle.vue?vue&type=style&index=0&id=23d4045f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d4045f",
  null
  
)

export default component.exports